import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import isEmpty from 'lodash/isEmpty';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
// import history from 'aurora-utils/history';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMImage } from 'aurora-components';
import { useHistory } from 'react-router-dom';

import styles from './styles';

const FiltersMobileHeader = ({ classes, heading, appliedFilters, onClickHandler }) => {
  const history = useHistory();

  useEffect(() => {
    if (history.action === 'POP') {
      history.goBack();
    }
  }, [history.action]);

  const handleBack = () => {
    history.goBack();
  };

  return (
    <div className={classes.mobileHeader}>
      <div className={classes.headingContainer}>
        <Button className={classNames(classes.btn, classes.backBtn)} onClick={handleBack}>
          <ADGMImage name='backArrowLong.svg' className={classes.backBtnIcon} alt='back' />
        </Button>
        <Typography variant='h5' className={classes.heading}>
          {keyEmptyCheck(heading)}
        </Typography>
      </div>
      <Button variant='contained' className={classNames(classes.btn, classes.showFiltersBtn)} onClick={onClickHandler}>
        <span className={classes.showFiltersBtnIcon}>
          {isEmpty(appliedFilters) ? (
            <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <rect x='0.5' y='0.5' width='31' height='31' fill='white' />
              <rect x='0.5' y='0.5' width='31' height='31' stroke='black' />
              <g clipPath='url(#clip0_4060_18476)'>
                <path d='M11.3861 16H8.83984' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M23.1582 16H14.6699' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M17.3287 21.4111H8.83984' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M23.1589 21.4111H20.6133' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M17.3287 10.5889H8.83984' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M23.1589 10.5889H20.6133' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
                <path
                  d='M11.3867 16.0014C11.3867 16.217 11.4292 16.4305 11.5117 16.6297C11.5942 16.829 11.7152 17.01 11.8676 17.1624C12.0201 17.3149 12.2011 17.4359 12.4004 17.5184C12.5996 17.6009 12.8131 17.6434 13.0287 17.6434C13.2443 17.6434 13.4579 17.6009 13.6571 17.5184C13.8563 17.4359 14.0373 17.3149 14.1898 17.1624C14.3423 17.01 14.4632 16.829 14.5457 16.6297C14.6282 16.4305 14.6707 16.217 14.6707 16.0014C14.6707 15.7857 14.6282 15.5722 14.5457 15.373C14.4632 15.1738 14.3423 14.9928 14.1898 14.8403C14.0373 14.6878 13.8563 14.5669 13.6571 14.4844C13.4579 14.4018 13.2443 14.3594 13.0287 14.3594C12.8131 14.3594 12.5996 14.4018 12.4004 14.4844C12.2011 14.5669 12.0201 14.6878 11.8676 14.8403C11.7152 14.9928 11.5942 15.1738 11.5117 15.373C11.4292 15.5722 11.3867 15.7857 11.3867 16.0014Z'
                  stroke='black'
                />
                <path
                  d='M17.3301 21.4125C17.3301 21.848 17.5031 22.2656 17.811 22.5736C18.1189 22.8815 18.5366 23.0545 18.9721 23.0545C19.4076 23.0545 19.8252 22.8815 20.1331 22.5736C20.4411 22.2656 20.6141 21.848 20.6141 21.4125C20.6141 20.977 20.4411 20.5594 20.1331 20.2514C19.8252 19.9435 19.4076 19.7705 18.9721 19.7705C18.5366 19.7705 18.1189 19.9435 17.811 20.2514C17.5031 20.5594 17.3301 20.977 17.3301 21.4125Z'
                  stroke='black'
                />
                <path
                  d='M17.3301 10.5902C17.3301 11.0257 17.5031 11.4434 17.811 11.7513C18.1189 12.0592 18.5366 12.2322 18.9721 12.2322C19.4076 12.2322 19.8252 12.0592 20.1331 11.7513C20.4411 11.4434 20.6141 11.0257 20.6141 10.5902C20.6141 10.1548 20.4411 9.73711 20.1331 9.42917C19.8252 9.12124 19.4076 8.94824 18.9721 8.94824C18.5366 8.94824 18.1189 9.12124 17.811 9.42917C17.5031 9.73711 17.3301 10.1548 17.3301 10.5902Z'
                  stroke='black'
                />
              </g>
              <defs>
                <clipPath id='clip0_4060_18476'>
                  <rect width='16' height='16' fill='white' transform='translate(8 8)' />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'>
              <rect x='0.5' y='4.5' width='35' height='35' rx='3.5' fill='#F8F8F8' />
              <circle cx='34' cy='6' r='5' fill='#D2374F' stroke='white' strokeWidth='2' />
              <path
                d='M20.5 17.0714H24.5'
                stroke='#484456'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M11.5 17.0714L14 17.0714'
                stroke='#484456'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M15.5 26.0714H11.5'
                stroke='#484456'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M24.5 26.0714H22'
                stroke='#484456'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M17 20.0714C18.6569 20.0714 20 18.7283 20 17.0714C20 15.4146 18.6569 14.0714 17 14.0714C15.3431 14.0714 14 15.4146 14 17.0714C14 18.7283 15.3431 20.0714 17 20.0714Z'
                stroke='#484456'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M19 29.0714C20.6569 29.0714 22 27.7283 22 26.0714C22 24.4146 20.6569 23.0714 19 23.0714C17.3431 23.0714 16 24.4146 16 26.0714C16 27.7283 17.3431 29.0714 19 29.0714Z'
                stroke='#484456'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <rect x='0.5' y='4.5' width='35' height='35' rx='3.5' stroke='#484456' />
            </svg>
          )}
        </span>
      </Button>
    </div>
  );
};

FiltersMobileHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  heading: PropTypes.object.isRequired,
  appliedFilters: PropTypes.object.isRequired,
  onClickHandler: PropTypes.func.isRequired,
};

FiltersMobileHeader.defaultProps = {};

export default withStyles(styles)(memo(FiltersMobileHeader));
